// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Add = require("@mui/icons-material/Add").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var Delete = require("@mui/icons-material/Delete").default;

function MM_cmp_type_settings(props) {
  var onDelete = props.onDelete;
  var onPrefixChange = props.onPrefixChange;
  var onColorChange = props.onColorChange;
  var onTypeChange = props.onTypeChange;
  var onAdd = props.onAdd;
  var availableColors = props.availableColors;
  var rndTypeSetting = function (ts) {
    var msg = ts.err;
    return JsxPPXReactSupport.createElementVariadicWithKey(ts.id, Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, [
                React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(TextField, {
                          value: ts.typ,
                          label: "Type",
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (__x) {
                                            Curry._2(onTypeChange, ts.id, __x);
                                          }), param);
                            })
                        }), MM_react_common.rndColorSelect(availableColors, ts.color, (function (__x) {
                            Curry._2(onColorChange, ts.id, __x);
                          }), "Color", undefined), React.createElement(TextField, {
                          value: ts.prefix,
                          label: "Prefix",
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (__x) {
                                            Curry._2(onPrefixChange, ts.id, __x);
                                          }), param);
                            })
                        }), JsxPPXReactSupport.createElementWithKey("delete-button", IconButton, {
                          onClick: (function (param) {
                              Curry._1(onDelete, ts.id);
                            }),
                          children: Caml_option.some(React.createElement(Delete, {}))
                        })),
                msg !== undefined ? React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, msg) : null
              ]);
  };
  return React.createElement(Expln_React_Column.make, {
              style: {
                marginTop: "5px"
              },
              children: Caml_option.some(null)
            }, props.typeSettings.map(rndTypeSetting), React.createElement(Expln_React_Row.make, {
                  alignItems: "baseline",
                  children: Caml_option.some(null)
                }, JsxPPXReactSupport.createElementWithKey("add-button", IconButton, {
                      onClick: (function (param) {
                          Curry._1(onAdd, undefined);
                        }),
                      children: Caml_option.some(React.createElement(Add, {}))
                    }), MM_react_common.rndSmallTextBtn(props.onRestoreDefaults, "Restore default type settings")));
}

var make = MM_cmp_type_settings;

exports.make = make;
/* react Not a pure module */
